<template>
  <div class="view-toggle">
    <button
      class="view-toggle-btn"
      :class="{ active: currentView === 'table' }"
      @click="$emit('update:modelValue', 'table')"
      :aria-pressed="currentView === 'table'"
      title="Табличный вид"
      type="button"
    >
      <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
        <!-- Таблица -->
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="2"
          :stroke="currentView === 'table' ? '#ffffff' : '#94a3b8'"
          stroke-width="2"
          fill="none"
        />
        <line
          x1="3"
          y1="8"
          x2="21"
          y2="8"
          :stroke="currentView === 'table' ? '#ffffff' : '#94a3b8'"
          stroke-width="1.5"
        />
        <line
          x1="3"
          y1="13"
          x2="21"
          y2="13"
          :stroke="currentView === 'table' ? '#ffffff' : '#94a3b8'"
          stroke-width="1.5"
        />
        <line
          x1="8"
          y1="3"
          x2="8"
          y2="21"
          :stroke="currentView === 'table' ? '#ffffff' : '#94a3b8'"
          stroke-width="1.5"
        />
        <line
          x1="13"
          y1="3"
          x2="13"
          y2="21"
          :stroke="currentView === 'table' ? '#ffffff' : '#94a3b8'"
          stroke-width="1.5"
        />
      </svg>
    </button>
    <button
      class="view-toggle-btn"
      :class="{ active: currentView === 'cards' }"
      @click="$emit('update:modelValue', 'cards')"
      :aria-pressed="currentView === 'cards'"
      title="Карточный вид"
      type="button"
    >
      <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
        <!-- Карточки -->
        <rect
          x="4"
          y="5"
          width="16"
          height="14"
          rx="2"
          :stroke="currentView === 'cards' ? '#ffffff' : '#94a3b8'"
          stroke-width="2"
          fill="none"
        />
        <rect
          x="7"
          y="8"
          width="10"
          height="9"
          rx="1"
          :stroke="currentView === 'cards' ? '#ffffff' : '#94a3b8'"
          stroke-width="1.5"
          fill="none"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "BaseViewToggle",
  props: {
    modelValue: {
      type: String,
      default: "table",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    currentView() {
      return this.modelValue;
    },
  },
};
</script>

<style scoped>
.view-toggle {
  display: flex;
  gap: 2px;
  height: 40px;
  padding: 2px;
  width: max-content;
  background: #fff;
  border-radius: 8px;
  box-shadow: none;
  border: 1px solid var(--color-dark);
  box-sizing: border-box;
  transition: background-color 0.3s ease;
}

.view-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  transition: background-color 0.2s ease, color 0.2s ease;
  outline: none;
}

.view-toggle-btn:focus-visible {
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.3);
}

.view-toggle-btn:hover:not(.active) {
  background: #e5e9fd;
}

.view-toggle-btn.active {
  color: white;
  z-index: 2;
}

.view-toggle-btn.active .icon {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}

.view-toggle-btn::before {
  content: "";
  position: absolute;
  inset: 1px;
  border-radius: 5px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: -1;
}

.view-toggle-btn.active::before {
  opacity: 1;
}

.icon {
  width: 18px;
  height: 18px;
  transition: transform 0.2s ease;
}
</style>
